// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__A7fYE","active":"tab_active__6cb6a"};